import mongoose from "mongoose";
import { match } from "@mssi/pssp-shared";

// Audits system events
// Logs administrative actions of HP employees (e.g. changing a feature flag, permissions, etc)

export interface Audit {
  _id: mongoose.Schema.Types.ObjectId;
  userId: string;
  customerId: string;
  userEmail: string;
  userName: string;
  timestamp: string;
  eventType: string;
  eventTarget?: string;
  rawData?: string;
}

export const AuditSchema = new mongoose.Schema<Audit>({
  userId: String,
  customerId: String,
  userEmail: String,
  userName: String,
  timestamp: String,
  eventType: String,
  eventTarget: String,
  rawData: String,
});

const props: (keyof Audit)[] = [
  "customerId",
  "userEmail",
  "userName",
  "timestamp",
  "eventType",
  "eventTarget",
  "rawData",
  "userId",
];

export const searchProps: (keyof Audit)[] = [
  "customerId",
  "userEmail",
  "userName",
  "timestamp",
  "eventType",
  "eventTarget",
  "rawData",
  "userId",
];

export function matches(a: Audit, b: Audit): boolean {
  return match(a, b, props);
}

export const auditUtils = {
  props,
  searchProps,
  matches,
};
